import { Responses } from './types'
import request from '@/helper/superagent-protected'
import rethrowApiError from './rethrow-api-error'
import store from '@/store'
// tslint:disable-next-line: import-spacing
import config  from '../../public/config.json'

export async function getNomenclatures(): Promise<Responses.INomenclature[]> {
  const apiUrl = store.getters.parameters('apiUrl')
  return request
    .get(`${apiUrl}/v0/nomenclatures/${config.nomenclatureHierarchy}`)
    .then((res: any) => res.body)
}

export async function getMarkets(): Promise<Responses.IMarket[]> {
  const apiUrl = store.getters.parameters('apiUrl')
  return request
    .get(`${apiUrl}/v0/nomenclatures/markets`)
    .then((res: any) => res.body)
}

export async function getCategories(): Promise<Responses.ICategory[]> {
  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/nomenclatures/categories`)
    .then((res: any) => res.body)
}

export async function getFamilies(): Promise<Responses.IFamily[]> {

  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/nomenclatures/families`)
    .then((res: any) => res.body)
}

export async function getRoots(): Promise<Responses.IRoot[]> {

  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/nomenclatures/roots`)
    .then((res: any) => res.body)
}

export async function getSectors(): Promise<Responses.ISector[]> {

  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/nomenclatures/sectors`)
    .then((res: any) => res.body)
}

export async function getSubMarkets(): Promise<Responses.ISubMarket[]> {

  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/nomenclatures/subMarkets`)
    .then((res: any) => res.body)
}

export async function getSegments(): Promise<Responses.ISegment[]> {

  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/nomenclatures/segments`)
    .then((res: any) => res.body)
}

